import { render, staticRenderFns } from "./OrderFoodCounter.vue?vue&type=template&id=c2923d22&scoped=true"
import script from "./OrderFoodCounter.vue?vue&type=script&lang=js"
export * from "./OrderFoodCounter.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodCounter.vue?vue&type=style&index=0&id=c2923d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2923d22",
  null
  
)

export default component.exports